import { render, staticRenderFns } from "./DepartmentReportForms.vue?vue&type=template&id=18d0081e&scoped=true&"
import script from "./DepartmentReportForms.vue?vue&type=script&lang=js&"
export * from "./DepartmentReportForms.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentReportForms.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DepartmentReportForms.vue?vue&type=style&index=1&id=18d0081e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0081e",
  null
  
)

export default component.exports